
export function needIndexComponent (chartComponent) {
  return !['text', 'borderBlock', 'filterBlock', 'signName', 'timeClock'].includes(chartComponent)
}
